import { Button, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { api, endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import { userRole } from "@/constant";
import { setUserDetails } from "@/redux/slices/user.slice";

export default function EditProfile() {
  //   const
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.user?.userDetails);

  const [IsLoading, setIsLoading] = useState(false);
  const [updateProfileData, setUpdateProfileData] = useState({
    name: "",
    email: "",
    loginId: "",
    phone: "",
  });
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const { name, email, phone, loginId } = updateProfileData;

  useEffect(() => {
    document.title = `${appConfig.name} - Edit Profile`;
    if (userDetails) {
      setUpdateProfileData({
        name: userDetails.name,
        email: userDetails.email,
        loginId: userDetails.loginId,
        phone: userDetails.phone,
        fax: userDetails.fax,
      });
    }
  }, [userDetails]);

  const handleFileUpload = (file) => {
    setImageUrl(URL.createObjectURL(file));
    let form = new FormData();
    form.append("avatar", file);
    setSelectedImage(form);
  };

  const onInputChange = (e) => {
    if (e.target.name !== "loginId") {
      setUpdateProfileData({
        ...updateProfileData,
        [e.target.name]: e.target.name === "loginId" ? e.target.value.toLowerCase().replace(/\s/g, "") : e.target.value,
      });
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      if (selectedImage) {
        await api.put(endpoint.update_user_avater, selectedImage);
      }
      const user = await api.put(endpoint.update_user_details, updateProfileData);
      dispatch(setUserDetails(user));
      navigate("/profile");
      Swal.fire({
        title: "Done!",
        text: "Profile Updated Successfully.",
        icon: "success",
        timer: 2000,
        button: false,
      });
    } catch {
      Swal.fire({
        title: "Oops...!",
        text: "Something went wrong.",
        icon: "error",
        timer: 2000,
        button: false,
      });
    }
    setSelectedImage(null);
    setImageUrl(null);
    setIsLoading(false);
  };

  return (
    <Spin spinning={IsLoading}>
      <div className="az-content-body p-0 px-md-3">
        <div className="row row-sm mg-b-15 mg-sm-b-20">
          <div className="col-lg-12">
            <div className="card card-dashboard-six">
              <div className="card-header">
                <div>
                  <label className="az-content-label">Profile</label>
                  <span className="d-block py-2">Update Profile Information</span>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <form onSubmit={submitHandler}>
                    <div className="mb-3">
                      <label htmlFor="name" className="form-label">
                        Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={name}
                        onChange={onInputChange}
                        id="name"
                        placeholder="Enter your name"
                      />
                    </div>
                    {userDetails?.role !== userRole.superAdmin ? (
                      <div className="mb-3">
                        <label htmlFor="loginId" className="form-label">
                          Login ID
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="loginId"
                          value={loginId}
                          onChange={onInputChange}
                          id="loginId"
                          placeholder="Enter you Login ID"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">
                        Email address
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={email}
                        onChange={onInputChange}
                        id="email"
                        placeholder="Enter your email"
                        disabled={userDetails?.role === userRole.superAdmin}
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="phone" className="form-label">
                        Phone Number
                      </label>
                      <div className="input-group">
                        <span className="input-group-text" id="basic-addon1">
                          +6
                        </span>
                        <input
                          type="number"
                          name="phone"
                          value={phone}
                          onChange={onInputChange}
                          className="form-control"
                          id="phone"
                          placeholder="Enter phone number"
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="select-image" className="form-label d-block">
                        Profile Photo
                      </label>

                      {imageUrl && selectedImage ? (
                        <div className="mt-2 text-center">
                          <div>Image Preview:</div>
                          <img src={imageUrl} alt={selectedImage?.name || "Avatar"} height="100px" style={{minWidth: 100}} />
                        </div>
                      ) : (
                        <>
                          <input
                            className="form-control"
                            accept="image/*"
                            type="file"
                            id="select-image"
                            style={{ display: "none" }}
                            onChange={(e) => handleFileUpload(e.target.files[0])}
                          />
                          <label htmlFor="select-image">
                            {userDetails?.avatar ? (
                              <img src={userDetails?.avatar} alt="" height="100px" className="rounded-3" />
                            ) : (
                              <img src="assets/images/avatar.png" alt="" height="100px" className="rounded-3" />
                            )}
                          </label>
                        </>
                      )}
                    </div>
                    <div className="d-flex align-items-center justify-content-end gap-2 pt-2">
                      <Button
                        type="primary"
                        htmlType="submit"
                        disabled={!name || (!loginId && userDetails?.role !== userRole.superAdmin)}
                      >
                        Update
                      </Button>
                      <Button type="primary" className="bg-secondary" onClick={() => navigate(-1)} htmlType="button">
                        Cancel
                      </Button>
                    </div>
                  </form>
                </div>
                <div className="col-md-6"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
}
